var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "eui-panel",
    {
      class: {
        "-osynlig": _vm.skaVaraOsynlig
      },
      staticStyle: { width: "100%", height: "100%" },
      attrs: {
        "vp-inaktiverad": _vm.skaVaraInaktiverad,
        disabled: _vm.skaVaraInaktiverad,
        "vp-osynlig": _vm.skaVaraOsynlig,
        "vp-visa-menyfaltet": _vm.vpArIRedigeralage,
        "vp-meny-config": _vm.menyConfig
      },
      on: {
        "update:vpMenyConfig": function($event) {
          _vm.menyConfig = $event
        },
        "update:vp-meny-config": function($event) {
          _vm.menyConfig = $event
        },
        "menyalternativ-valt-i-panel": _vm.onMenyalternativValtIPanel
      },
      scopedSlots: _vm._u([
        {
          key: "huvudtext",
          fn: function() {
            return [
              _c("span", { staticClass: "ellipsis" }, [
                _vm._v(
                  "Konto " +
                    _vm._s(_vm.vpWidgetData.accountid) +
                    " – " +
                    _vm._s(_vm.vpWidgetData.accountname)
                )
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          {
            staticClass: "bildlank",
            attrs: {
              tabindex: "-1",
              href: "/kontoutdrag/" + _vm.vpWidgetData.accountid
            }
          },
          [
            _c(
              "p",
              { staticClass: "somh1", staticStyle: { color: "lightseagreen" } },
              [
                _vm._v(
                  "Utgående balans " + _vm._s(_vm.vpWidgetData.closingbalance)
                )
              ]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }